export const BIG_NUMBER_LENGTH = 7;
export const VERY_BIG_NUMBER_LENGTH = 9;
export const ZERO_DECIMAL_PLACES = 0;
export const DEFAULT_ROUNDING = 2;
export const DECIMAL_PLACES = 4;
